import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { BadgeComponent } from '../common/badge/badge.component';
import { BadgeColor } from '../common/badge/badge.types';
import { BoxComponent } from '../common/box/box.component';
import { HeadingComponent } from '../common/heading/heading.component';
import { IconColorDirective } from '../common/icon/directives/icon-color.directive';
import { IconComponent } from '../common/icon/icon.component';
import { RtTooltip } from '../common/tooltip/tooltip.directive';
import { IconName } from '../icons-container/icons.type';

@Component({
  selector: 'rt-new-item-button',
  templateUrl: 'new-item-button.component.html',
  styleUrls: ['./new-item-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BadgeComponent,
    BoxComponent,
    HeadingComponent,
    IconColorDirective,
    IconComponent,
    RtTooltip,
    TranslatePipe,
  ],
})
export class NewItemButtonComponent {
  @Input() public icon: IconName;
  @Input() public heading: string = '';
  @Input() public subheading: string = '';
  @Input() public badgeText?: string;
  @Input() public badgeVariant: BadgeColor;
  @Input() public disabled = false;
}
